module.exports = __webpack_public_path__ + "img/61-r.c735cf8f.png";